export default {
  terms:
    'Tekemällä tilauksen hyväksyt <TermsLink>käyttöehtomme</TermsLink> ja <PrivacyPolicyLink>tietosuojakäytäntömme</PrivacyPolicyLink>.',
};
